import React from 'react';
import { Row } from 'reactstrap';
import { Profile } from '../../components/my-profile/profile/Profile';
import { Colxx } from '../../components/common/CustomBootstrap';
import { ProfilePreferences } from '../../components/my-profile/preference/ProfilePreferences';
import { AboutMe } from '../../components/my-profile/about-me/AboutMe';
import { useState } from 'react';
import { ProfileSubscription } from '../../components/my-profile/subscription/ProfileSubscription';
import { useUserContext } from '../../context/UserContext';
import { LoadingContainer } from '../../components/common/LoadingContainer';
import userAPI from '../../services/API/user';
import { NotificationManager } from '../../components/common/react-notifications';
import { ErrorComponent } from '../../components/common/error-component/ErrorComponent';
import { useLayoutContext } from '../../context/LayoutContext';
import moment from 'moment';
import { ShippingAddress } from '../../components/settings/shipping-address/ShippingAddress';
import { PageTitleHeader } from '../../components/common/PageTitleHeader';
import { NewsLetter } from '../../components/my-profile/newsLetter/newsLetter';
import { Accounts } from '../../components/my-profile/accounts/accounts';
import { MEMBER_SUBSCRIPTION_STATUS } from '../../constants/appConst';

export const MyProfile = () => {
  const [updatingParts, setUpdatingParts] = useState({});
  const [subscribe, setSubscribe] = useState(false);
  const {
    user,
    setUser,
    loadingUserDetails,
    usuallyWears,
    braSize,
    heightData,
    bodyTypes,
  } = useUserContext();
  const { showNavBar } = useLayoutContext();
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const isSM = windowWidth <= 900;
  React.useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);

  const handleUserChange = async (updatingPart, changes, callBack) => {
    if (changes) {
      // user data
      let payload = {
        id: parseInt(user.id),
        user: changes,
      };
      try {
        setUpdatingParts((updatingParts) => ({
          ...updatingParts,
          [updatingPart]: true,
        }));
        let updatedUser = await userAPI.updateUser(payload);
        NotificationManager.success({
          message: 'Successfully updated!',
        });
        if (updatedUser) {
          setUser(updatedUser);
          if (callBack) {
            callBack();
          }
        }
      } catch (error) {
        console.error(error);
      }

      setUpdatingParts((updatingParts) => ({
        ...updatingParts,
        [updatingPart]: false,
      }));
    }
  };

  const handleUpdateAcceptMarketing = async (accept) => {
    let payload = {
      user_id: parseInt(user.id),
      accept,
    };
    try {
      await userAPI.updateUserAcceptMarketing(payload);
      setSubscribe(accept);
      NotificationManager.success({
        message: 'Successfully updated!',
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancelUpdate = (updatingPart) => {
    const newUpdatingParts = { ...updatingParts };
    newUpdatingParts[updatingPart] = false;
    setUpdatingParts(newUpdatingParts);
  };

  const theMainComponent = (
    <Row
      style={
        !showNavBar
          ? { justifyContent: 'center' }
          : { paddingLeft: 15, paddingRight: 15 }
      }
    >
      <Colxx xxs='12' className='mb-4'>
        <PageTitleHeader title={'Profile'} />
      </Colxx>
      <Colxx xxs='12' className='mb-4'>
        <Row>
          <Colxx
            xxs={isSM ? '12' : '5'}
            className={`p-0 d-flex ${isSM ? 'mb-3' : ''}`}
          >
            <Profile
              updatingParts={updatingParts}
              profileData={user}
              handleDataChange={handleUserChange}
              handleCancelUpdate={handleCancelUpdate}
            />
          </Colxx>
          <Colxx xxs={isSM ? '12' : '7'} className={'p-0'}>
            {/* <ProfileSubscription
              isMemeber={
                user?.member_status !== MEMBER_SUBSCRIPTION_STATUS.CANCELLED
              }
              subscribedOn={
                user && user.member_since
                  ? moment(user.member_since).format('Do MMM, YYYY')
                  : 'unknown'
              }
              isSM={windowWidth <= 600}
              nextPayment='unkown'
            /> */}
            <div>
              <AboutMe
                updatingParts={updatingParts}
                profileData={user}
                braSize={braSize}
                heightData={heightData}
                bodyTypes={bodyTypes}
                usuallyWearsData={usuallyWears}
                handleDataChange={handleUserChange}
                isSM={windowWidth <= 600}
              />
            </div>
            {/* <div className='mt-3'>
              <ProfilePreferences
                updatingParts={updatingParts}
                profileData={user}
                handleDataChange={handleUserChange}
              />
            </div> */}
            <div className='mt-3'>
              <Accounts
                updatingParts={updatingParts}
                profileData={user}
                handleDataChange={handleUserChange}
                isSM={windowWidth <= 600}
              />
            </div>
            <div className='mt-3'>
              <ShippingAddress
                updatingParts={updatingParts}
                shippingAddress={user.shipping_address}
                handleDataChange={handleUserChange}
                handleCancelUpdate={handleCancelUpdate}
                isSM={windowWidth <= 600}
              />
            </div>
          </Colxx>
        </Row>
      </Colxx>
    </Row>
  );

  const isUserLoaded = !loadingUserDetails && Object.keys(user).length > 0;
  return (
    <Row
      className='mt-4'
      style={!showNavBar ? { justifyContent: 'center' } : {}}
    >
      <Colxx xxs='12' xl={'8'}>
        {loadingUserDetails ? (
          <LoadingContainer />
        ) : isUserLoaded ? (
          theMainComponent
        ) : (
          <ErrorComponent
            title={'Something went wrong'}
            description={
              'Check your internet connection and please try again. '
            }
          />
        )}
      </Colxx>
    </Row>
  );
};
